"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _scss = require("@scss");

var _getDataProps = _interopRequireDefault(require("@utils/getDataProps"));

var _Icon = _interopRequireDefault(require("@components/Icon"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["icons", "size", "gap", "classes", "iconsColor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SocialIcons = function SocialIcons(_ref) {
  var _ref$icons = _ref.icons,
      icons = _ref$icons === void 0 ? [] : _ref$icons,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 'modulor' : _ref$gap,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    link: '',
    wrapper: ''
  } : _ref$classes,
      _ref$iconsColor = _ref.iconsColor,
      iconsColor = _ref$iconsColor === void 0 ? 'currentColor' : _ref$iconsColor,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("ul", _extends({}, (0, _getDataProps["default"])(props), {
    className: (0, _scss.cls)(_stylesModule["default"]['wrapper'], classes['wrapper'], 'list-unstyled')
  }), icons.map(function (icon, i) {
    var _icon$classes, _icon$classes2, _icon$classes3;

    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i,
      className: (0, _scss.cls)('d-inline-block', icon === null || icon === void 0 ? void 0 : (_icon$classes = icon.classes) === null || _icon$classes === void 0 ? void 0 : _icon$classes.list, "".concat(i === icons.length - 1 ? '' : "mr-".concat(gap)))
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: icon.url,
      className: (0, _scss.cls)(_stylesModule["default"]['link'], classes['link'], icon === null || icon === void 0 ? void 0 : (_icon$classes2 = icon.classes) === null || _icon$classes2 === void 0 ? void 0 : _icon$classes2.link),
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": icon.label,
      title: icon.label,
      onClick: function onClick(e) {
        if (typeof (icon === null || icon === void 0 ? void 0 : icon.onClick) === 'function') {
          icon === null || icon === void 0 ? void 0 : icon.onClick(e);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: icon.name,
      size: size,
      alt: icon.label,
      color: "currentColor",
      classes: {
        icon: (0, _scss.cls)(icon.color ? "text-".concat(icon.color) : iconsColor ? "text-".concat(iconsColor) : '', icon === null || icon === void 0 ? void 0 : (_icon$classes3 = icon.classes) === null || _icon$classes3 === void 0 ? void 0 : _icon$classes3.icon)
      }
    })));
  }));
};

var _default = SocialIcons;
exports["default"] = _default;